import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    dialogContent: {
      padding: '64px',

      '&:first-child': {
        paddingTop: '64px',
      },
    },
    paper: {
      borderImageSource: 'none',
      borderColor: COLORS.PRIMARY,
    },
    missingInfos: {
      margin: '30px auto',
      maxWidth: '80%',
    },
    infoDetails: {
      fontSize: 18,

      '&.missing': {
        color: COLORS.ERROR,
      },
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(4),
    },
    buttonContainer: {
      marginTop: theme.spacing(6),
      display: 'flex',
      justifyContent: 'center',
    },
    updateBtn: {
      padding: '10px 40px',
      height: 50,
    },
  }),
);
